<template>
  <div v-if="menuIsOpen" id="wrapper-lu-column-menu" class="mhv-100 h-100" v-click-outside="mutationIsOpen">
    <router-link to="/" class="logo text-center">
      <img :src="logoImg" alt="" height="46">
    </router-link>
    <ul id="menu-list" role="tablist">
        <li class="side-nav-title side-nav-item">{{ $t('Navigation') }}</li>
        <li v-for="(el, index) in menuItems" :key="index">
          <template v-if="el.parent">
            <b-btn v-b-toggle="el.id" variant="link" class="side-nav-link">
                <i :class="el.icon"></i>
                <span> {{ el.name }} </span>
                <i class="dripicons dripicons-chevron-right"></i>
                <i class="dripicons dripicons-chevron-down"></i>
            </b-btn>
            <b-collapse
              tag="ul"
              :id="el.id"
              accordion="accordion-app"
              role="tabpanel"
              class="side-nav-second-level"
              :visible="el.childs.some(el => el.path === $router.currentRoute.path)"
            >
              <li v-for="(child, index) in el.childs" :key="index">
                <router-link :to="child.path">{{ child.name }}</router-link>
              </li>
            </b-collapse>
          </template>
          <template v-else>
            <router-link :to="el.path" class="side-nav-link">
              <i :class="el.icon"></i>
              <span> {{ el.name }} </span>
            </router-link>
          </template>
        </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  props: {
    menuItems: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState('settings', ['logoImg']),
    ...mapState('menu', ['menuIsOpen'])
  },
  methods: {
    ...mapMutations('menu', ['mutationIsOpen']),
    ...mapActions('menu', ['menuOnResize'])
  },
  mounted () {
    this.menuOnResize()
  }

}
</script>

<style lang="sass" scoped>
#wrapper-lu-column-menu
  background: linear-gradient(135deg,#8f75da 0,$primaryThemeColor 60%)
  @media(max-width: $xl)
    position: fixed
    z-index: 10
  a,
  button
    color: #cedce4
    font-size: 15px
    &:hover
      color: white
      text-decoration: none
  .logo
    height: 80px
    display: flex
    align-items: center
    justify-content: center
  #menu-list
    padding: 0
    button,
    a
      color: #cedce4
      display: block
      position: relative
      width: 100%
      text-align: left
      &.router-link-exact-active
        color: white
    .dripicons-chevron-right
      display: none
    .dripicons-chevron-down
      display: inline-block
    .dripicons
      float: right
      margin: 0 !important
    .collapsed
      .dripicons-chevron-right
        display: inline-block
      .dripicons-chevron-down
        display: none
    .side-nav-title
      padding: 12px 30px
      letter-spacing: .05em
      cursor: default
      font-size: 11px
      text-transform: uppercase
      color: #cedce4
      font-weight: 700
    .side-nav-link
      padding: 15px 30px
      display: block
      i
        margin: 0 10px 0 3px
        line-height: 1.0625rem
        text-align: center
        vertical-align: middle
        width: 20px
    .side-nav-second-level
      button,
      a
        padding: 8px 20px 8px 68px
      .dripicons
        position: relative
        right: 13px
    .side-nav-third-level
      button,
      a
        padding: 8px 20px 8px 84px
</style>
